import { jsx as _jsx } from "react/jsx-runtime";
import { theme } from "../theme";
import { Icon } from "../icon";
/**
 * A component that displays a flag icon.
 *
 * @returns {JSX.Element} The rendered flag icon component.
 */
export const FlagIcon = () => (_jsx(Icon, { name: "flag", size: 16, color: theme.color.pink100 }));
